// extracted by mini-css-extract-plugin
module.exports = {"root":"CookieConsent_root__1sM9M","message":"CookieConsent_message__2hQ95","cookieLink":"CookieConsent_cookieLink__1y710","continueBtn":"CookieConsent_continueBtn__1fmW0"};